export default "__VITE_ASSET__CpvFxW5e__"